import AssociationHelper from '@/Utility/Association/AssociationHelper';
import MessageBoxViewModel from '@/ViewModels/Controls/MessageBoxViewModel';
import RADApplication from '@/Management/RADApplication';
import Loader from '@/Utility/Loader';
import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import ComponentManager from '@/Management/ComponentManager';
import ResourceManager from '@/Management/ResourceManager';

export default class ObjectDeletionHelper extends AssociationHelper {

    private readonly DeleteWarningResourceIdentifier = "LISTVIEW_DELETE_WARNING";
    private readonly DeleteWithFollowingWarningResourceIdentifier = "LISTVIEW_DELETE_WARNING_WITH_FOLLOWING";

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    public ExecuteCheck(): void {
        this.TryToDelete();
    }

    public TryToDelete() {
        if (RADApplication.getInstance().isSystemParamSetAndTrue('Gui.ShowTryToDelete')) {
            Loader.getInstance().show();

            RADEnvironmentProxy.getInstance().tryToDeleteObject({
                pdTypeName: this.pdTypeName,
                pdoIDs: this.affectedObjectIds
            }).then(tryDeletion => {
                if (this.validateStatus(tryDeletion)) {
                    //self.state("AfterTryToDele");

                    if (tryDeletion.objectsToDelete.length === 1 && tryDeletion.objectsToDelete[0].objects.length === 1) {
                        this.showMessageBox(ResourceManager.getInstance().get(this.DeleteWarningResourceIdentifier));
                    }
                    else if (tryDeletion.objectsToDelete.length >= 1) {
                        const msg = this.CreateMsgForDelete(ResourceManager.getInstance(), tryDeletion.objectsToDelete);

                        this.showMessageBox(msg);
                    }

                }
            }).always(() => {
                Loader.getInstance().hide();
            });
            this.state('TryToDeleteSent');
        }
        else {
            this.showMessageBox(ResourceManager.getInstance().get(this.DeleteWarningResourceIdentifier));
        }
    }

    private showMessageBox(msg: string) {
        let msgVM = MessageBoxViewModel.createWarningMessageBox(msg, this.confirmDeletionCallback, {}, true);
        RADApplication.getInstance().showMessageBox(msgVM);


        this.state("WaitingForDelete");
    }

    private CreateMsgForDelete(RM, objectsToDelete) {
        let msgRaw = RM.get(this.DeleteWithFollowingWarningResourceIdentifier);

        let sb = "";
        let itemErgNameValue = '';
        objectsToDelete.forEach(item => {
            if (sb.length > 0) {
                sb += ', ';
            }
            if (item.objects.length > 1) {
                itemErgNameValue = item.ergNamePluralized;
            } else {
                itemErgNameValue = item.ergName;
            }

            sb += item.objects.length + 'x ' + RM.get(itemErgNameValue);
        });

        return msgRaw.replace("$$items$$", sb);
    }
}

ComponentManager.setUtility('ObjectDeletionHelper', ObjectDeletionHelper, 'RADPresentation.HTMLClient.DefaultViewExtensions');